module.exports = __webpack_public_path__ + "static/media/powerdocs_icons_V2_transparent.a9f5363f.gif";